var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25005 4.62669C2.65068 4.62669 2.17033 5.10704 2.17033 5.70641V22.4981C2.17033 23.0974 2.65068 23.5778 3.25005 23.5778H22.7501C23.3494 23.5778 23.8298 23.0974 23.8298 22.4981V8.41474C23.8298 7.81537 23.3494 7.33502 22.7501 7.33502H11.2803C10.8503 7.33502 10.4343 7.16182 10.1296 6.85708L8.05771 4.78521C7.95619 4.68369 7.81701 4.62669 7.67818 4.62669H3.25005ZM1.07977 5.70641C1.07977 4.50474 2.04838 3.53613 3.25005 3.53613H7.67818C8.10809 3.53613 8.52412 3.70934 8.82885 4.01407L10.9007 6.08595C11.0022 6.18746 11.1414 6.24447 11.2803 6.24447H22.7501C23.9517 6.24447 24.9203 7.21307 24.9203 8.41474V22.4981C24.9203 23.6997 23.9517 24.6684 22.7501 24.6684H3.25005C2.04838 24.6684 1.07977 23.6997 1.07977 22.4981V5.70641Z",
    fill: "#17253F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/folder.692c28aa96203dde02bc04dd14ad1168.svg";